import { RADAR_FINAL_SIZE, TILE_SIZE, TILE_COUNT } from './radar-constants.mjs';

// convert a pixel location to a file/tile combination
const pixelToFile = (xPixel, yPixel) => {
	const xTile = Math.floor(xPixel / TILE_SIZE.x);
	const yTile = Math.floor(yPixel / TILE_SIZE.y);
	if (xTile < 0 || xTile > TILE_COUNT.x || yTile < 0 || yTile > TILE_COUNT.y) return false;
	return `${yTile}-${xTile}`;
};

// convert a pixel location in the overall map to a pixel location on the tile set
const modTile = (xPixel, yPixel) => {
	// adjust for additional 1 tile when odd
	const x = (Math.floor(xPixel) % (TILE_SIZE.x));
	const y = (Math.floor(yPixel) % (TILE_SIZE.y));

	return { x, y };
};

// YEETLAB: upstream hard-coded a 2x2 tile grid, which caps the base map at
// 1360x774 and was the real reason the radar could not grow past the 367px band.
// Build whatever grid the requested size needs instead. Tiles are only rebuilt
// when the grid shape actually changes, so a re-render is cheap.
const fillGrid = (container, tileName, sourceXY, cols, rows) => {
	if (!container) return;

	const shape = `${cols}x${rows}`;
	if (container.dataset.grid !== shape) {
		container.replaceChildren();
		for (let index = 0; index < cols * rows; index += 1) {
			const img = document.createElement('img');
			img.width = TILE_SIZE.x;
			img.height = TILE_SIZE.y;
			container.append(img);
		}
		container.dataset.grid = shape;
	}
	// the container has to be exactly wide enough or the images wrap on the wrong column
	container.style.width = `${cols * TILE_SIZE.x}px`;

	Array.from(container.children).forEach((elem, index) => {
		// always set the size to flow the images correctly
		elem.width = TILE_SIZE.x;
		elem.height = TILE_SIZE.y;

		const col = index % cols;
		const row = Math.floor(index / cols);
		const tile = pixelToFile(sourceXY.x + col * TILE_SIZE.x, sourceXY.y + row * TILE_SIZE.y);

		// off the edge of the national map: leave the slot blank rather than
		// requesting the page url, which is what an empty src does
		if (!tile) {
			elem.removeAttribute('src');
			elem.style.visibility = 'hidden';
			return;
		}

		elem.style.visibility = '';
		const newSource = `images/maps/radar/${tileName}-${tile}.webp`;
		if (elem.getAttribute('src') === newSource) return;
		elem.src = newSource;
	});
};

// creates the radar background map image and overlay transparency
// which remain fixed on the page as the radar image changes in layered divs
const setTiles = (data) => {
	const {
		sourceXY,
		elemId,
		finalSize = RADAR_FINAL_SIZE,
	} = data;
	const elemIdFull = `${elemId}-html`;

	// calculate the shift of the upper left tile
	const tileShift = modTile(sourceXY.x, sourceXY.y);

	// Enough tiles to cover the visible area after that shift. The grid is
	// positioned against .weather-display, not against .main, so it also has to
	// span the header above the map; one spare row covers that plus rounding.
	const cols = Math.max(2, Math.ceil((tileShift.x + finalSize.width) / TILE_SIZE.x));
	const rows = Math.ceil((tileShift.y + finalSize.height) / TILE_SIZE.y) + 1;

	[['.map-tiles', 'map'], ['.overlay-tiles', 'overlay']].forEach(([selector, tileName]) => {
		const container = document.querySelector(`#${elemIdFull} ${selector}`);
		fillGrid(container, tileName, sourceXY, cols, rows);
		if (!container) return;
		container.style.top = `${-tileShift.y}px`;
		container.style.left = `${-tileShift.x}px`;
	});
};

export default setTiles;
